import factory from './factory'

export default {
  hasCountryFilter (state) {
    return state.appliedFilters.hasOwnProperty(factory.countryField)
  }
}
